const DEVTOOLS_TANSTACK_QUERY_STORAGE_KEY =
	'user.settings.devtools.tanstack.query.show';
const DEVTOOLS_TANSTACK_ROUTER_STORAGE_KEY =
	'user.settings.devtools.tanstack.router.show';

export const getShowTanstackQueryDevTools = () => {
	const value = localStorage.getItem(DEVTOOLS_TANSTACK_QUERY_STORAGE_KEY);
	return value === 'true';
};

export const setShowTanstackQueryDevTools = (value: boolean) => {
	localStorage.setItem(DEVTOOLS_TANSTACK_QUERY_STORAGE_KEY, value.toString());
};

export const getShowTanstackRouterDevTools = () => {
	const value = localStorage.getItem(DEVTOOLS_TANSTACK_ROUTER_STORAGE_KEY);
	return value === 'true';
};

export const setShowTanstackRouterDevTools = (value: boolean) => {
	localStorage.setItem(DEVTOOLS_TANSTACK_ROUTER_STORAGE_KEY, value.toString());
};
